// src/data/cropData.js
import rice from "../assets/crops/rice.jpg";
import wheat from "../assets/crops/wheat.jpg";
import maize from "../assets/crops/maize.jpg";
import potato from "../assets/crops/potato.jpg";
import Strawberry from "../assets/crops/Strawberry.jpg"
import wheatPopup from "../assets/crops/wheat-popup.jpeg"
import ricePopup from "../assets/crops/rice-popup.jpeg"
import Maizepopup from "../assets/crops/maize-popup.jpeg"
import Citrus from "../assets/crops/Citrus.jpg";
import Patato from "../assets/crops/alooPopup.jpeg";
import Sugarcanepop from "../assets/crops/vegetable-popup.jpeg"
import Sugarcane from "../assets/crops/Sugarcane.jpg"
import Vegetables from "../assets/crops/Vegetables.jpg"

export const crops = [

  {
    id: 2,
    name: "Rice",
    image: rice,
    popupImage: ricePopup,
    description: "Rice feeds more than half the world."
  },
  {
        id: 3,
        name: "Wheat",
        image: wheat,
        popupImage: wheatPopup,
        // description: "Wheat is useds for bread, pasta, etc."
  },

  {
    id: 4,
    name: "Maize",
    image: maize,
    popupImage:  Maizepopup,
    description: "Maize is a global food & feed crop."
  },
  {
    id: 5,
    name: "Potato",
    image: potato,
    popupImage: Patato,
    description: "Potatoes are rich, filling, and versatile."
  },
  {
    id: 6,
    name: "Sugar cane",
    image: Sugarcane,
    popupImage: Sugarcanepop,
    description: "Sugarcane is widely used for sugar production"
  },
  {
    id: 7,
    name: "Strawberry",
    image: Strawberry,
    description: "banana feeds more than half the world."
  },
  // {
  //   id: 8,
  //   name: "Strawberry",
  //   image: wheat,
  //   description: "apple is used for bread, pasta, etc."
  // },
  {
    id: 9,
    name: "Citrus ",
    image: Citrus,
    description: "grapes is a global food & feed crop."
  },
  {
    id: 10,
    name: "Vegetables",
    image: Vegetables,
    description: "sugar cane are rich, filling and versatile."
  },
];

// // src/data/cropData.js
// import cotton from "../assets/crops/cotton.jpg";
// import rice from "../assets/crops/wheat.jpg";
// import wheat from "../assets/crops/cotton.jpg";
// import maize from "../assets/crops/wheat.jpg";
// import potato from "../assets/crops/cotton.jpg";

// /* ✅ NEW POPUP IMAGES */
// import cottonPopup from "../assets/crops/cotton-popup.jpg";
// import ricePopup from "../assets/crops/rice-popup.jpg";
// import wheatPopup from "../assets/crops/wheat-popup.jpg";
// import maizePopup from "../assets/crops/maize-popup.jpg";
// import potatoPopup from "../assets/crops/potato-popup.jpg";

// export const crops = [
//   {
//     id: 1,
//     name: "Cotton",
//     image: cotton,
//     popupImage: cottonPopup,
//     description: "Cotton is widely used in textiles."
//   },
//   {
//     id: 2,
//     name: "Rice",
//     image: rice,
//     popupImage: ricePopup,
//     description: "Rice feeds more than half the world."
//   },
//   {
//     id: 3,
//     name: "Wheat",
//     image: wheat,
//     popupImage: wheatPopup,
//     description: "Wheat is used for bread, pasta, etc."
//   },
//   {
//     id: 4,
//     name: "Maize",
//     image: maize,
//     popupImage: maizePopup,
//     description: "Maize is a global food & feed crop."
//   },
//   {
//     id: 5,
//     name: "Potato",
//     image: potato,
//     popupImage: potatoPopup,
//     description: "Potatoes are rich, filling, and versatile."
//   },
//   {
//     id: 6,
//     name: "Mango",
//     image: cotton,
//     popupImage: cottonPopup,
//     description: "Mango is a delicious summer fruit."
//   },
//   {
//     id: 7,
//     name: "Banana",
//     image: rice,
//     popupImage: ricePopup,
//     description: "Bananas are rich in potassium."
//   },
//   {
//     id: 8,
//     name: "Apple",
//     image: wheat,
//     popupImage: wheatPopup,
//     description: "Apples are healthy and crispy."
//   },
//   {
//     id: 9,
//     name: "Grapes",
//     image: maize,
//     popupImage: maizePopup,
//     description: "Grapes are used fresh and dried."
//   },
//   {
//     id: 10,
//     name: "Sugar Cane",
//     image: potato,
//     popupImage: potatoPopup,
//     description: "Sugarcane is used to make sugar."
//   },
// ];

